import Gravity from 'gravityglobal-parent/assets/js/global-functions';

const initCookieBar = () => {
  const cookieBar = document.querySelector('.gg-cookie-bar');

  if (!cookieBar) {
    return;
  }

  const hideCookieBar = () => {
    cookieBar.dataset.hasCookie = true;
  };

  const showCookieBar = () => {
    cookieBar.dataset.hasCookie = false;
  };

  const cookieSettings = Gravity.getCookie('gg-cookie-settings');

  if (cookieSettings) {
    hideCookieBar();
  } else {
    showCookieBar();
  }

  const cookieSwitcher = cookieBar.querySelector('.gravity-block-cookie-switcher');
  const cookieAcceptAllButton = cookieBar.querySelector('.gg-cookie-bar__accept');
  const cookieRejectButton = cookieBar.querySelector('.gg-cookie-bar__reject');

  cookieSwitcher.addEventListener('gg-cookie-added', () => {
    hideCookieBar();
  });

  Gravity.clickEnterListener(cookieAcceptAllButton, () => {
    cookieSwitcher.dispatchEvent(new Event('gg-cookie-enable-all'));
    hideCookieBar();
  });

  Gravity.clickEnterListener(cookieRejectButton, () => {
    cookieSwitcher.dispatchEvent(new Event('gg-cookie-enable-necessary'));
    hideCookieBar();
  });
};

export default initCookieBar;
